import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import { BookingModel } from '../../../../../models/booking.model';
import { AlertService } from '../../../../../services/alert.service';
import { BookingService } from '../../../../../services/booking.service';
import { InvoiceService } from '../../../../../services/invoice.service';

@Component({
  selector: 'app-user-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrl: './booking-details.component.scss',
  standalone: false,
})
export class UserBookingDetailsComponent implements OnInit {
  public isLoading = true;
  public booking: BookingModel;
  constructor(
    private bookingService: BookingService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private invoiceService: InvoiceService,
    private alertService: AlertService
  ) {}

  public ngOnInit(): void {
    const bookingId = this.activatedRoute.snapshot.params['bookingId'];
    if (!bookingId) {
      return;
    }
    this.getBooking(+atob(bookingId));
  }

  getBooking(bookingId: number): void {
    this.bookingService
      .getBookingById(bookingId)
      .pipe(take(1))
      .subscribe({
        next: booking => {
          this.isLoading = false;
          this.booking = booking;
        },
        error: error => {
          this.isLoading = false;
          console.error('Error fetching booking', error);
        },
      });
  }

  onGoBack(): void {
    this.location.back();
  }

  public onDownloadInvoice(): void {
    if (!this.booking.invoice) {
      return;
    }
    this.invoiceService
      .downloadInvoice(this.booking.invoice.id)
      .pipe(take(1))
      .subscribe({
        next: blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Rechnung-${this.booking.invoice.invoiceNr}.pdf`;
          a.click();
        },
        error: error => {
          console.error('Error downloading invoice', error);
          this.alertService.showErrorAlert(
            'Die Rechnung konnte nicht heruntergeladen werden'
          );
        },
      });
  }
}
